import React, { PropsWithChildren } from "react";
import * as styles from "./Milestones.module.scss";
import IntroText from "components/IntroText/IntroText";

type Props = {
  introText?: string;
};
const Milestones: React.FC<PropsWithChildren<Props>> = ({
  introText,
  children
}) => {
  const hasChildren = React.Children.count(children) > 0;
  return (
    <div data-content-name="milestones">
      {introText && (
        <IntroText className={styles.introText}>{introText}</IntroText>
      )}
      {hasChildren && <div className={styles.container}>{children}</div>}
    </div>
  );
};

export default Milestones;
